import { N } from "./dates";

/**
 * Deterministic seeded data generators. Same seed → same series, so the mock
 * dashboard is fully reproducible with no backend.
 */

/* ---------- Seeded daily series ---------- */
export function genDaily(seed: number, base: number, amp: number, trend: number): number[] {
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  const out: number[] = [];
  for (let i = 0; i < N; i++) {
    s = (s * 16807) % 2147483647;
    const r = s / 2147483647 - 0.5;
    const season = Math.sin((i / 30.4) * Math.PI * 2) * amp * 0.6;
    const tr = trend * (i - N / 2);
    out.push(Math.max(0, base + tr + season + r * amp * 1.4));
  }
  return out;
}

/* ---------- Hash + PRNG helpers (record-level determinism) ---------- */
export function fnv1a(str: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

export function makeRng(seed: number): () => number {
  let s = seed >>> 0 || 1;
  return () => {
    s = (Math.imul(s, 1664525) + 1013904223) >>> 0;
    return s / 4294967296;
  };
}
